/*
Replace
resourceName with your resource Name :) Take care about different writings!
/!\ ResourceName resourceName ResourceNames resourceNames /!\
Keep an eye on pluralized namings in here :)

*/

import { createSlice, createSelector } from "@reduxjs/toolkit";
import { defaultInitialState } from "../defaultInitialState";
import {
  defaultList,
  defaultListFail,
  defaultListSuccess,
  defaultShow,
  defaultShowFail,
  defaultShowSuccess,
  defaultAddToDictionary,
  defaultCreate,
  defaultCreateSuccess,
  defaultCreateFail,
  defaultUpdate,
  defaultUpdateSuccess,
  defaultUpdateFail,
  defaultRemove,
  defaultRemoveFail,
  defaultRemoveSuccess,
} from "../defaultReducers";

const addToProjectDashboardDictionary = (state, action) => {
  const projectDashboardId =
    action.payload?.attributes?.project_dashboard_id?.toString();
  if (projectDashboardId) {
    const dictionary = state.projectDashboardDictionary;
    if (!dictionary[projectDashboardId]) {
      dictionary[projectDashboardId] = [action.payload?.id];
    } else {
      if (!dictionary[projectDashboardId].includes(action.payload?.id)) {
        dictionary[projectDashboardId].push(action.payload?.id);
      }
    }
    state.projectDashboardDictionary = { ...dictionary };
  }
};

export const dashboardPanelsSlice = createSlice({
  name: "dashboardPanels",
  initialState: { ...defaultInitialState, projectDashboardDictionary: {} },
  reducers: {
    list: defaultList,
    listSuccess: defaultListSuccess,
    listFail: defaultListFail,
    show: defaultShow,
    showSuccess: defaultShowSuccess,
    showFail: defaultShowFail,
    create: defaultCreate,
    createSuccess: (state, action) => {
      defaultCreateSuccess(state, action);
      addToProjectDashboardDictionary(state, action);
    },
    createFail: defaultCreateFail,
    update: defaultUpdate,
    updateSuccess: defaultUpdateSuccess,
    updateFail: defaultUpdateFail,
    addToDictionary: (state, action) => {
      defaultAddToDictionary(state, action);
      addToProjectDashboardDictionary(state, action);
    },
    remove: defaultRemove,
    removeSuccess: (state, action) => {
      defaultRemoveSuccess(state, action);
      const projectDashboardId =
        action.payload?.attributes?.project_dashboard_id?.toString();
      if (projectDashboardId) {
        const dictionary = state.projectDashboardDictionary;
        if (dictionary[projectDashboardId]) {
          dictionary[projectDashboardId] = dictionary[
            projectDashboardId
          ].filter((id) => id !== action.payload.id);
          state.projectDashboardDictionary = { ...dictionary };
        }
      }
    },
    removeFail: defaultRemoveFail,
  },
});

export const {
  create: createDashboardPanel,
  show: showDashboardPanel,
  update: updateDashboardPanel,
  list: listDashboardPanels,
  remove: removeDashboardPanel,
} = dashboardPanelsSlice.actions;

export const actions = dashboardPanelsSlice.actions;

// The function below is called a selector and allows us to select a value from
// the state. Selectors can also be defined inline where they're used instead of
// in the slice file. For example: `useSelector((state) => state.counter.value)`
export const dashboardPanels = (state) =>
  state.dashboardPanels.idsList.map(
    (id) => state.dashboardPanels.dictionary[id]
  );
export const dashboardPanel = (state) =>
  state.dashboardPanels.showId &&
  state.dashboardPanels.dictionary[state.dashboardPanels.showId];
export const dashboardPanelAttributes = (state) =>
  dashboardPanel(state)?.attributes;
export const dashboardPanelRelationships = (state) =>
  dashboardPanel(state)?.relationships;
export const dashboardPanelId = (state) => state.dashboardPanels.showId;

export const getDashboardPanel = createSelector(
  (state) => state.dashboardPanels.dictionary,
  (_, id) => id,
  (dictionary, id) => {
    return id && dictionary && dictionary[id];
  }
);

export const getDashboardPanelAttributes = createSelector(
  (state) => state.dashboardPanels.dictionary,

  (_, id) => id,
  (dictionary, id) => {
    return id && dictionary && dictionary[id]?.attributes;
  }
);

export const getDashboardPanelRelationships = createSelector(
  (state) => state.dashboardPanels.dictionary,
  (_, id) => id,
  (dictionary, id) => {
    return id && dictionary && dictionary[id]?.relationships;
  }
);

export const getDashboardPanels = createSelector(
  (state) => state.dashboardPanels.dictionary,
  (_, ids) => ids,
  (dictionary, ids) => {
    return ids && dictionary && ids.map((id) => dictionary[id]);
  }
);

export default dashboardPanelsSlice.reducer;
